module.exports = __webpack_public_path__ + "fonts/fb4860e4-3e80-46aa-92f9-63d03e5db476.bccf8e51.ttf";